// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeoplePersonGear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 6c-1.109 0-2 .891-2 2s.891 2 2 2 2-.891 2-2-.891-2-2-2zm4 2c0 2.213-1.787 4-4 4s-4-1.787-4-4 1.787-4 4-4 4 1.787 4 4zM4 18h6.579a2.4 2.4 0 0 1 .324 2H2v-2.22c0-1.834 1.492-3.03 2.953-3.71C6.478 13.358 8.375 13 10 13c.405 0 .827.022 1.256.067a2.396 2.396 0 0 1-1.86 1.808.479.479 0 0 0-.277.165c-1.144.1-2.352.39-3.322.842C4.508 16.482 4 17.176 4 17.781zm15.684 1.878a1.5 1.5 0 0 0-2.017.91.27.27 0 0 1-.225.193c-.303.027-.61.027-.917-.002-.118-.011-.206-.11-.23-.226a1.497 1.497 0 0 0-2.263-.973c-.1.062-.232.066-.322-.012a4.971 4.971 0 0 1-.632-.664.27.27 0 0 1-.014-.296 1.502 1.502 0 0 0-.852-2.139.27.27 0 0 1-.193-.224 4.963 4.963 0 0 1 .002-.917c.011-.119.11-.206.226-.23a1.497 1.497 0 0 0 .973-2.263c-.062-.101-.066-.233.012-.322.203-.233.426-.444.664-.632a.27.27 0 0 1 .296-.015 1.5 1.5 0 0 0 2.139-.852.27.27 0 0 1 .224-.193c.303-.027.61-.027.917.003.119.01.206.109.23.225a1.498 1.498 0 0 0 2.263.974c.101-.063.233-.066.322.012.233.203.444.425.632.664a.27.27 0 0 1 .015.296 1.5 1.5 0 0 0 .852 2.139.27.27 0 0 1 .193.224c.027.303.027.61-.003.917-.011.118-.109.206-.225.23a1.498 1.498 0 0 0-.974 2.263c.063.1.066.232-.012.322a4.971 4.971 0 0 1-.664.632.27.27 0 0 1-.296.014c-.039-.021-.08-.04-.12-.058zm-3.476-2.04a2 2 0 1 0 1.58-3.673 2 2 0 0 0-1.58 3.673z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeoplePersonGear;
